import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import { Provider } from "react-redux";
import { store } from "./app/store";
import { setCredentials } from "./features/auth/authSlice";
import AppRouter from "./routes/AppRouter";

try {
  const accessToken = localStorage.getItem("accessToken");
  const refreshToken = localStorage.getItem("refreshToken");
  const raw = localStorage.getItem("partnersViewUser");
  let parsed = null;
  if (raw) {
    parsed = JSON.parse(raw);
  }
  const token = accessToken || parsed?.accessToken;
  if (token) {
    store.dispatch(
      setCredentials({
        accessToken: token,
        refreshToken: refreshToken || parsed?.refreshToken || null,
        user: parsed?.user ?? null,
      })
    );
  }
} catch {
  /* ignore */
}

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <AppRouter />
    </Provider>
  </React.StrictMode>
);

